import { TransferMethod } from "../../core/models/entities/LogoOptions";

const SCREEN_PRINT = "screen print";

export const isScreenPrintMethod = (m: TransferMethod): boolean =>
  m.displayName.toLowerCase().includes(SCREEN_PRINT) ||
  m.type.toLowerCase().includes(SCREEN_PRINT);

/**
 * Filters screen-print methods out of selectable option lists — users must not
 * be able to PICK them in the frontend (they are only created via NAV import).
 * Never removes the currently selected method, so an existing/cloned logo that
 * already has a screen-print method keeps displaying it.
 */
export const excludeScreenPrintMethods = (
  methods: TransferMethod[],
  selectedKey?: string | null
): TransferMethod[] =>
  methods.filter((m) => !isScreenPrintMethod(m) || m.key === selectedKey);
